// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1g1xI","largestCol":"styles_largestCol__lqQ8Z","smallestCol":"styles_smallestCol__2e3_x"};